import { render, staticRenderFns } from "./SideNavMenu.vue?vue&type=template&id=42f990a2&scoped=true&"
import script from "./SideNavMenu.vue?vue&type=script&lang=js&"
export * from "./SideNavMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f990a2",
  null
  
)

export default component.exports